import React from 'react';
import Headertwo from './Headertwo';

const PrivacyPolicy = () => {
    return (
        <>
        <div className='group-section'>
                        <Headertwo />
                        <div className='banner-item-About-usf'>
                            {/* <div>
                                <h2>Our Mission</h2>
                                <h4>To provide the most powerful user-friendly sports auction software to
                                    sports fanatics around the world.</h4>
                            </div> */}
                        </div>
        
        
                    </div>
        <div className="body p-5">
            <div>
                <strong>
                    <span style={{ fontSize: '26px' }}>
                        <span data-custom-class="title">
                            <h1>PRIVACY POLICY</h1>
                        </span>
                    </span>
                </strong>
            </div>
            <div>
                <span style={{ color: 'rgb(127, 127, 127)' }}>
                    <strong>
                        <span style={{ fontSize: '15px' }}>
                            <span data-custom-class="subtitle">
                                Last updated 
                                <span className="question"> September 16, 2025</span>
                            </span>
                        </span>
                    </strong>
                </span>
            </div>
            <div><br /></div>
            <div style={{ lineHeight: '1.5' }}>
                <span style={{ color: 'rgb(127, 127, 127)' }}>
                    <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
                        <span data-custom-class="body_text">
                            This Privacy Notice for 
                            <span className="question noTranslate">2025, Gadi Enterprises, Inc.</span> (
                            "<strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>")
                            describes how and why we might access, collect, store, use, and/or share (
                            "<strong>process</strong>") your personal information when you use our services (
                            "<strong>Services</strong>"), including when you:
                        </span>
                    </span>
                </span>
            </div>
            <ul>
                <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
                    <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                        <span data-custom-class="body_text">
                            Visit our website 
                            <span style={{ color: 'rgb(0, 58, 250)' }}>
                                <a href="https://www.xcutta.com/" target="_blank" rel="noopener noreferrer" data-custom-class="link">https://www.xcutta.com/</a>
                            </span> 
                            or any website of ours that links to this Privacy Notice.
                        </span>
                    </span>
                </li>
            </ul>
            <div>
                <span style={{ fontSize: '15px', color: 'rgb(127, 127, 127)' }}>
                    <span data-custom-class="body_text">
                        <span style={{ color: 'rgb(89, 89, 89)' }}>
                            {/* Placeholder for additional content if needed */}
                        </span>
                    </span>
                </span>
            </div>
            <ul>
                <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
                    <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                        <span data-custom-class="body_text">
                            Download and use our mobile application 
                            <span className="question">Xcutta</span>
                            or any other application of ours that links to this Privacy Notice.
                        </span>
                    </span>
                </li>
            </ul>
            <div style={{ lineHeight: '1.5' }}>
                <ul>
                    <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
                        <span style={{ fontSize: '15px' }}>
                            Use <span className="question">Xcutta</span>. 
                            <span className="question">Fantasy sports auction software empowers users to create and participate in custom sports calcutta auctions.</span>
                        </span>
                    </li>
                </ul>
                <ul>
                    <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
                        <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                            Engage with us in other related ways, including any sales, marketing, or events.
                        </span>
                    </li>
                </ul>
                <div style={{ lineHeight: '1.5' }}>
                    <span style={{ fontSize: '15px' }}>
                        <strong>Questions or concerns? </strong>Reading this Privacy Notice will help you understand your privacy rights and choices. We are responsible for making decisions about how your personal information is processed. If you do not agree with our policies and practices, please do not use our Services.
                        If you still have any questions or concerns, please contact us at <span className="question noTranslate">support@xcutta.com</span>.
                    </span>
                </div>
            </div>
            <br />
            <div style={{ lineHeight: '1.5' }}>
      <h2>SUMMARY OF KEY POINTS</h2>
      <p>
        <strong>
          This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our 
        </strong>
        <a href="#toc" style={{ color: 'rgb(0, 58, 250)' }}>
          <strong> table of contents </strong>
        </a>
        <strong> below to find the section you are looking for.</strong>
      </p>
      <p>
        <strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more about 
        <a href="#personalinfo" style={{ color: 'rgb(0, 58, 250)' }}> personal information you disclose to us</a>.
      </p>
      <p>
        <strong>Do we process any sensitive personal information? </strong>Some of the information may be considered "special" or "sensitive" in certain jurisdictions, for example your racial or ethnic origins, sexual orientation, and religious beliefs. We do not process sensitive personal information.
      </p>
      <p>
        <strong>Do we collect any information from third parties?</strong> We do not collect any information from third parties.
      </p>
      <p>
        <strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Learn more about 
        <a href="#infouse" style={{ color: 'rgb(0, 58, 250)' }}> how we process your information</a>.
      </p>
      <p>
        <strong>In what situations and with which parties do we share personal information?</strong> We may share information in specific situations and with specific third parties. Learn more about 
        <a href="#whoshare" style={{ color: 'rgb(0, 58, 250)' }}> when and with whom we share your personal information</a>.
      </p>
    </div>
    <div style={{ lineHeight: '1.5' }}>
      <div>
        <strong>How do we keep your information safe?</strong> We have adequate 
        organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Learn more about 
        <a href="#infosafe" style={{ color: 'rgb(0, 58, 250)' }}> how we keep your information safe</a>.
      </div>
      <div style={{ marginTop: '10px' }}>
        <strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Learn more about 
        <a href="#privacyrights" style={{ color: 'rgb(0, 58, 250)' }}> your privacy rights</a>.
      </div>
      <div style={{ marginTop: '10px' }}>
        <strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by 
        <a href="https://app.termly.io/notify/94bf533d-5a0e-49aa-bb1f-688fdb24cf50" rel="noopener noreferrer" target="_blank" style={{ color: 'rgb(0, 58, 250)' }}> submitting a data subject access request</a>, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.
      </div>
      <div style={{ marginTop: '10px' }}>
        Want to learn more about what we do with any information we collect? 
        <a href="#toc" style={{ color: 'rgb(0, 58, 250)' }}> Review the Privacy Notice in full</a>.
      </div>
      <div id="toc" style={{ marginTop: '20px' }}>
        <h2 style={{ color: 'black' }}>TABLE OF CONTENTS</h2>
        <p>
          <a href="#infocollect" style={{ color: 'rgb(0, 58, 250)' }}>1. WHAT INFORMATION DO WE COLLECT?</a>
        </p>
        <p>
          <a href="#infouse" style={{ color: 'rgb(0, 58, 250)' }}>2. HOW DO WE PROCESS YOUR INFORMATION?</a>
        </p>
      </div>
    </div>
    <div style={{ lineHeight: '1.5' }}>
      <div>
        <a href="#legalbases" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?
        </a>
      </div>
      <div>
        <a href="#whoshare" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
        </a>
      </div>
      <div>
        <a href="#inforetain" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          5. HOW LONG DO WE KEEP YOUR INFORMATION?
        </a>
      </div>
      <div>
        <a href="#infosafe" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          6. HOW DO WE KEEP YOUR INFORMATION SAFE?
        </a>
      </div>
      <div>
        <a href="#infominors" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          7. DO WE COLLECT INFORMATION FROM MINORS?
        </a>
      </div>
      <div>
        <a href="#privacyrights" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          8. WHAT ARE YOUR PRIVACY RIGHTS?
        </a>
      </div>
      <div>
        <a href="#DNT" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          9. CONTROLS FOR DO-NOT-TRACK FEATURES
        </a>
      </div>
      <div>
        <a href="#uslaws" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
        </a>
      </div>
      <div>
        <a href="#policyupdates" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          11. DO WE MAKE UPDATES TO THIS NOTICE?
        </a>
      </div>
      <div>
        <a href="#contact" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
        </a>
      </div>
      <div>
        <a href="#request" style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
          13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
        </a>
      </div>
      <div id="infocollect" style={{ lineHeight: '1.5' }}>
        <h2>1. WHAT INFORMATION DO WE COLLECT?</h2>
        <h3>Personal information you disclose to us</h3>
        <p>
          <strong><em>In Short:</em></strong> 
          <em>We collect personal information that you provide to us.</em>
        </p>
        <p>
          We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
        </p>
        <strong>Personal Information Provided by You.</strong> 
        <p>
          The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:
        </p>
        <ul>
          <li>names</li>
          <li>phone numbers</li>
          <li>email addresses</li>
          <li>mailing addresses</li>
          <li>usernames</li>
          <li>passwords</li>
        </ul>
        <div id="sensitiveinfo" style={{ lineHeight: '1.5' }}>
          <strong>Sensitive Information.</strong> We do not process sensitive information.
        </div>
        <p>
          All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
        </p>
      </div>
      <div id="infouse" style={{ lineHeight: '1.5' }}>
        <h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
        <p>
          <strong><em>In Short: </em></strong>
          <em>
            We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We process the personal information for the following purposes listed below. We may also process your information for other purposes only with your prior explicit consent.
          </em>
        </p>
      </div>
    </div>
    <div style={{ lineHeight: '1.5' }}>
      <div>
        <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
          <strong>
            We process your personal information for a variety of reasons, depending on how you interact with our Services, including:
          </strong>
        </span>
      </div>
      <ul>
        <li style={{ lineHeight: '1.5', color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
          <strong>To facilitate account creation and authentication and otherwise manage user accounts.</strong> 
          We may process your information so you can create and log in to your account, as well as keep your account in working order.
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* Placeholder for potential content */}
      
      <p>This section is currently empty. Please add relevant information here.</p>
      <ul>
        {/* Empty list, use real content if necessary */}
        <li>Placeholder Item 1</li>
        <li>Placeholder Item 2</li>
        <li>Placeholder Item 3</li>
      </ul>
      <p>More content can be added here.</p>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <h2>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</h2>
      <p>
        <strong>In Short: </strong>We only process your personal information when we believe it is necessary and we have a valid legal reason (i.e. legal basis) to do so under applicable law, 
        like with your consent, to comply with laws, to provide you with services to enter into or fulfill our contractual obligations, to protect your rights, or to fulfill our legitimate business interests.
      </p>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          <strong>To save or protect an individual's vital interest.</strong> We may process your information when necessary to save or protect an individual’s vital interest, such as to prevent harm.
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* EU/UK Section */}
      <div style={{ marginBottom: '1em' }}>
        <em>
          <strong>
            <u>If you are located in the EU or UK, this section applies to you.</u>
          </strong>
        </em>
      </div>
      <div>
        The General Data Protection Regulation (GDPR) and UK GDPR require us to explain the valid legal bases we rely on in order to process your personal information. As such, we may rely on the following legal bases to process your personal information:
      </div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Consent.</strong> We may process your information if you have given us permission to use your personal information for a specific purpose. You can withdraw your consent at any time. Learn more about 
          <a href="#withdrawconsent" style={{ color: 'rgb(0, 58, 250)' }}> withdrawing your consent</a>.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Legal Obligations.</strong> We may process your information where we believe it is necessary for compliance with our legal obligations, such as to cooperate with a law enforcement body or regulatory agency, exercise or defend our legal rights, or disclose your information as evidence in litigation in which we are involved.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Vital Interests.</strong> We may process your information where we believe it is necessary to protect your vital interests or the vital interests of a third party, such as situations involving potential threats to the safety of any person.
        </li>
      </ul>
      {/* Canada Section */}
      <div style={{ marginTop: '2em', marginBottom: '1em' }}>
        <strong>
          <u>
            <em>If you are located in Canada, this section applies to you.</em>
          </u>
        </strong>
      </div>
      <div>
        We may process your information if you have given us specific permission (i.e. express consent) to use your personal information for a specific purpose, or in situations where your permission can be inferred (i.e. implied consent). You can 
        <a href="#withdrawconsent" style={{ color: 'rgb(0, 58, 250)' }}> withdraw your consent</a> at any time.
      </div>
      
      <div>
        In some exceptional cases, we may be legally permitted under applicable law to process your information without your consent, including, for example:
      </div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          If collection is clearly in the interests of an individual and consent cannot be obtained in a timely way.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          For investigations and fraud detection and prevention.
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          For business transactions provided certain conditions are met.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If it is contained in a witness statement and the collection is necessary to assess, process, or settle an insurance claim.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          For identifying injured, ill, or deceased persons and communicating with next of kin.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If we have reasonable grounds to believe an individual has been, is, or may be a victim of financial abuse.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If it is reasonable to expect that collection and use with consent would compromise the availability or accuracy of the information and the collection is reasonable for purposes related to investigating a breach of an agreement or a contravention of the laws of Canada or a province.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If disclosure is required to comply with a subpoena, warrant, court order, or rules of the court relating to the production of records.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If it was produced by an individual in the course of their employment, business, or profession and the collection is consistent with the purposes for which the information was produced.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If the collection is solely for journalistic, artistic, or literary purposes.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          If the information is publicly available and is specified by the regulations.
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* Section 4: Sharing Personal Information */}
      <div id="whoshare" style={{ marginBottom: '2em' }}>
        <h2>4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>
        <strong><em>In Short:</em></strong>
        <em> We may share information in specific situations described in this section and/or with the following third parties.</em>
      </div>
      <div>
        We may need to share your personal information in the following situations:
      </div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
        </li>
      </ul>
      {/* Section 5: Retaining Personal Information */}
      <div id="inforetain" style={{ marginTop: '2em' }}>
        <h2>5. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>
        <strong><em>In Short: </em></strong>
        <em>We keep your information for as long as necessary to fulfill the purposes outlined in this Privacy Notice unless otherwise required by law.</em>
      </div>
      <div>
        We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than the period of time in which users have an account with us.
      </div>
      <div>
        When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* Section 6: How Do We Keep Your Information Safe */}
      <div id="infosafe">
        <h2>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
        <strong><em>In Short:</em></strong>
        <em> We aim to protect your personal information through a system of organizational and technical security measures.</em>
      </div>
      <div style={{ margin: '1em 0' }}>
        We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure. Therefore, we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. 
        Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.
      </div>
      {/* Section 7: Do We Collect Information from Minors */}
      <div id="infominors" style={{ margin: '2em 0' }}>
        <h2>7. DO WE COLLECT INFORMATION FROM MINORS?</h2>
        <strong><em>In Short:</em></strong>
        <em> We do not knowingly collect data from or market to children under 18 years of age or the equivalent age as specified by law in your jurisdiction.</em>
      </div>
      <div>
        We do not knowingly collect, solicit data from, or market to children under 18 years of age or the equivalent age as specified by law in your jurisdiction, nor do we knowingly sell such personal information. By using the Services, you represent that you are at least 18 years old or the equivalent age as specified by law in your jurisdiction, or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. 
        If we learn that personal information from users less than 18 years of age or the equivalent age as specified by law in your jurisdiction has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. 
        If you become aware of any data we may have collected from children under age 18 or the equivalent age as specified by law in your jurisdiction, please contact us at <span style={{ color: 'rgb(89, 89, 89)' }}>support@xcutta.com</span>.
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* Section 8: Your Privacy Rights */}
      <div id="privacyrights">
        <h2>8. WHAT ARE YOUR PRIVACY RIGHTS?</h2>
        <strong><em>In Short:</em></strong>
        <em>
          Depending on your state of residence in the US or in some regions, such as the European Economic Area (EEA), United Kingdom (UK), Switzerland, and Canada, you have rights that allow you greater access to and control over your personal information. You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.
        </em>
      </div>
      <div style={{ margin: '1em 0' }}>
        In some regions (like the EEA, UK, Switzerland, and Canada), you have certain rights under applicable data protection laws. These may include:
        <ul>
          <li>Request access and obtain a copy of your personal information.</li>
          <li>Request rectification or erasure.</li>
          <li>Restrict the processing of your personal information.</li>
          <li>If applicable, the right to data portability.</li>
          <li>Not to be subject to automated decision-making.</li>
        </ul>
        If a decision that produces legal or similarly significant effects is made solely by automated means, we will inform you, explain the main factors, and offer a simple way to request human review. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us using the details provided in the section <a href="#contact" style={{ color: 'rgb(0, 58, 250)' }}>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>.
      </div>
      <div style={{ margin: '1em 0' }}>
        We will consider and act upon any request in accordance with applicable data protection laws.
      </div>
      <div style={{ margin: '1em 0' }}>
        If you are located in the EEA or UK and believe we are unlawfully processing your personal information, you also have the right to complain to your <a href="https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm" style={{ color: 'rgb(0, 58, 250)' }} rel="noopener noreferrer" target="_blank">Member State data protection authority</a> or <a href="https://ico.org.uk/make-a-complaint/data-protection-complaints/data-protection-complaints/" style={{ color: 'rgb(0, 58, 250)' }} rel="noopener noreferrer" target="_blank">UK data protection authority</a>.
      </div>
      <div style={{ margin: '1em 0' }}>
        If you are located in Switzerland, you may contact the <a href="https://www.edoeb.admin.ch/edoeb/en/home.html" style={{ color: 'rgb(0, 58, 250)' }} rel="noopener noreferrer" target="_blank">Federal Data Protection and Information Commissioner</a>.
      </div>
      {/* Withdrawing Consent Section */}
      <div id="withdrawconsent" style={{ margin: '2em 0' }}>
        <strong><u>Withdrawing your consent:</u></strong> If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us using the details provided in the section <a href="#contact" style={{ color: 'rgb(0, 58, 250)' }}>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a> below.
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      {/* Note on Withdrawal of Consent */}
      <div style={{ marginBottom: '1em' }}>
        <span>
          However, please note that this will not affect the lawfulness of the processing before its withdrawal nor,
          when applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
        </span>
      </div>
      {/* Account Information Section */}
      <div style={{ marginBottom: '1em' }}>
        <h3>Account Information</h3>
        <span>
          If you would at any time like to review or change the information in your account or terminate your account, you can:
        </span>
      </div>
      
      <ul style={{ margin: '1em 0' }}>
        <li>
          Log in to your account settings and update your user account.
        </li>
      </ul>
      <div style={{ marginBottom: '1em' }}>
        Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with applicable legal requirements.
      </div>
      {/* Contact Information */}
      <div style={{ marginBottom: '1em' }}>
        If you have questions or comments about your privacy rights, you may email us at <span style={{ color: 'rgb(0, 58, 250)' }}>support@xcutta.com</span>.
      </div>
      {/* Do-Not-Track Section */}
      <div id="DNT" style={{ marginBottom: '1em' }}>
        <h2>9. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
        <span>
          Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. 
          At this stage, no uniform technology standard for recognizing and implementing DNT signals has been finalized. 
          As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. 
          If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Notice.
        </span>
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      
      {/* Do Not Track Signals Notification */}
      <div style={{ marginBottom: '1em' }}>
        <span>
          California law requires us to let you know how we respond to web browser DNT signals. Because there currently is not an industry or legal standard for recognizing or honoring DNT signals, we do not respond to them at this time.
        </span>
      </div>
      {/* United States Residents Privacy Rights */}
      <div id="uslaws" style={{ marginBottom: '1em' }}>
        <h2>10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h2>
        <strong><em>In Short:</em></strong>
        <em>
          If you are a resident of California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia, you may have the right to request access to and receive details about the personal information we maintain about you and how we have processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. More information is provided below.
        </em>
        <strong>
          <h3>Categories of Personal Information We Collect</h3>
        </strong>
        <span>
          The table below shows the categories of personal information we have collected in the past twelve (12) months. The table includes illustrative examples of each category and does not reflect the personal information we collect from you. For a comprehensive inventory of all personal information we process, please refer to the section {" "}
          <a href="#infocollect" style={{ color: 'rgb(0, 58, 250)' }}>WHAT INFORMATION DO WE COLLECT?</a>.
        </span>
      </div>
      {/* Information Collection Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        
        <thead>
          <tr>
            <th style={{ border: '1px solid black', textAlign: 'left', padding: '8px' }}>Category</th>
            <th style={{ border: '1px solid black', textAlign: 'left', padding: '8px' }}>Examples</th>
            <th style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>Collected</th>
          </tr>
        </thead>
        
        <tbody>
          {/* Example row for Identifiers */}
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>A. Identifiers</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal identifier, online identifier, Internet Protocol address, email address, and account name</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          {/* Example row for California Customer Records */}
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>B. Personal information as defined in the California Customer Records statute</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Name, contact information, education, employment, employment history, and financial information</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          {/* Could add additional rows as needed */}
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>C. Protected classification characteristics under state or federal law</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Gender, age, date of birth, race and ethnicity, national origin, marital status, and other demographic data</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          {/* Additional rows... (D, E, F, etc.) */}
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>D. Commercial information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Transaction information, purchase history, financial details, and payment information</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>E. Biometric information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Fingerprints and voiceprints</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>F. Internet or other similar network activity</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Browsing history, search history, online behavior, interest data, and interactions with our and other websites, applications, systems, and advertisements</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>G. Geolocation data</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Device location</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>H. Audio, electronic, sensory, or similar information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Images and audio, video or call recordings created in connection with our business activities</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>I. Professional or employment-related information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Business contact details in order to provide you our Services at a business level or job title, work history, and professional qualifications if you apply for a job with us</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>J. Education Information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Student records and directory information</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>K. Inferences drawn from collected personal information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}>Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual’s preferences and characteristics</td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '8px' }}>L. Sensitive personal Information</td>
            <td style={{ border: '1px solid black', padding: '8px' }}></td>
            <td style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>NO</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <div>
        We may also collect other personal information outside of these categories through instances where you interact with us in person, online, or by phone or mail in the context of:
      </div>
      <ul>
        <li>Receiving help through our customer support channels;</li>
        <li>Participation in customer surveys or contests; and</li>
        <li>Facilitation in the delivery of our Services and to respond to your inquiries.</li>
      </ul>
      <div>
        We will use and retain the collected personal information as needed to provide the Services or for:
      </div>
      <ul>
        <li>
          Category H - <span style={{ fontWeight: 'bold' }}>As long as the user has an account with us</span>
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      
      <div>
        <strong>
          <h3>Sources of Personal Information</h3>
        </strong>
        <span>
          Learn more about the sources of personal information we collect in 
          <a href="#infocollect" style={{ color: 'rgb(0, 58, 250)' }}>
            <span> WHAT INFORMATION DO WE COLLECT?</span>
          </a>.
        </span>
      </div>
      <div><br/></div>
      <div>
        <strong>
          <h3>How We Use and Share Personal Information</h3>
        </strong>
        <span>
          Learn more about how we use your personal information in the section, 
          <a href="#infouse" style={{ color: 'rgb(0, 58, 250)' }}>
            <span> HOW DO WE PROCESS YOUR INFORMATION?</span>
          </a>.
        </span>
      </div>
      <div><br/></div>
      <div>
        <strong>Will your information be shared with anyone else?</strong>
      </div>
      <div><br/></div>
      <div>
        <span>
          We may disclose your personal information with our service providers pursuant to a written contract between us and each service provider. Learn more about how we disclose personal information in the section, 
          <a href="#whoshare" style={{ color: 'rgb(0, 58, 250)' }}>
            <span> WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
          </a>.
        </span>
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <div>
        We may use your personal information for our own business purposes, such as for undertaking internal research for technological development and demonstration. This is not considered to be 
        "selling" of your personal information.
      </div>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <div>
        <strong>
          <h3>Your Rights</h3>
        </strong>
        <span>
          You have rights under certain US state data protection laws. However, these rights are not absolute, and in certain cases, we may decline your request as permitted by law. These rights include:
        </span>
      </div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to know</strong> whether or not we are processing your personal data.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to access</strong> your personal data.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to correct</strong> inaccuracies in your personal data.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to request</strong> the deletion of your personal data.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to obtain a copy</strong> of the personal data you previously shared with us.
        </li>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to non-discrimination</strong> for exercising your rights.
        </li>
      </ul>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          <strong>Right to opt out</strong> of the processing of your personal data if it is used for targeted advertising (or sharing as defined under California’s privacy law), the sale of personal data, or profiling in furtherance of decisions that produce legal or similarly significant effects ( "profiling").
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <div>
        <span>Depending upon the state where you live, you may also have the following rights:</span>
      </div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to access the categories of personal data being processed (as permitted by applicable law, including the privacy law in Minnesota).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to obtain a list of the categories of third parties to which we have disclosed personal data (as permitted by applicable law, including the privacy law in California, Delaware, and Maryland).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to obtain a list of specific third parties to which we have disclosed personal data (as permitted by applicable law, including the privacy law in Minnesota and Oregon).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to review, understand, question, and correct how personal data has been profiled (as permitted by applicable law, including the privacy law in Minnesota).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to limit use and disclosure of sensitive personal data (as permitted by applicable law, including the privacy law in California).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}><br/></div>
      <ul>
        <li style={{ lineHeight: '1.5' }}>
          Right to opt out of the collection of sensitive data and personal data collected through the operation of a voice or facial recognition feature (as permitted by applicable law, including the privacy law in Florida).
        </li>
      </ul>
      <div style={{ lineHeight: '1.5' }}>
        <strong>
          <h3>How to Exercise Your Rights</h3>
        </strong>
        <span>
          To exercise these rights, you can contact us 
          by submitting a 
          <a 
            href="https://app.termly.io/notify/94bf533d-5a0e-49aa-bb1f-688fdb24cf50" 
            rel="noopener noreferrer" 
            target="_blank" 
            style={{ color: 'rgb(0, 58, 250)' }}
          >
            <span>data subject access request</span>
          </a>
          , 
          by visiting 
          <span style={{ color: 'rgb(0, 58, 250)' }}>
            <a 
              href="https://www.xcutta.com/ContactUs" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              https://www.xcutta.com/ContactUs
            </a>
          </span> 
          , or by referring to the contact details at the bottom of this document.
        </span>
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <div>
        We will honor your opt-out preferences if you enact the 
        <a 
          href="https://globalprivacycontrol.org/" 
          rel="noopener noreferrer" 
          target="_blank" 
          style={{ color: 'rgb(0, 58, 250)' }}
        >
          <span>Global Privacy Control</span>
        </a> (GPC) opt-out signal on your browser.
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        Under certain US state data protection laws, you can designate an 
        authorized agent to make a request on your behalf. We may deny a request from an 
        authorized agent that does not submit proof that they have been validly 
        authorized to act on your behalf in accordance with applicable laws.
      </div>
      <strong>
        <h3>Request Verification</h3>
      </strong>
      <div>
        Upon receiving your request, we will need to verify your identity to ensure you are the same person about whom we have the information in our system. We will only use personal information provided in your request to verify your identity or authority to make the request. However, if we cannot verify your identity from the information already maintained by us, we may request that you provide additional information for the purposes of verifying your identity and for security or fraud-prevention purposes.
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        If you submit the request through an authorized agent, we may need to collect additional information to verify your identity before processing your request, and the agent will need to provide written and signed permission from you to submit such a request on your behalf.
      </div>
      <strong>
        <h3>Appeals</h3>
      </strong>
      <div>
        Under certain US state data protection laws, if we decline to take action regarding your request, you may appeal our decision by emailing us at 
        <span style={{ color: 'rgb(0, 58, 250)' }}>
          <a href="mailto:support@xcutta.com">support@xcutta.com</a>
        </span>. We will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If your appeal is denied, you may submit a complaint to your state attorney general.
      </div>
      <strong>
        <h3>California "Shine The Light" Law</h3>
      </strong>
      <div>
        California Civil Code Section 1798.83, also known as the "Shine The Light" law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us by using the contact details provided in the section 
        <a style={{ color: 'rgb(0, 58, 250)' }} href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>.
      </div>
    </div>
    <div style={{ lineHeight: '1.5', fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
      <div id="policyupdates">
        <strong>
          <h2>11. DO WE MAKE UPDATES TO THIS NOTICE?</h2>
        </strong>
        <em>
          <strong>In Short: </strong>
          Yes, we will update this notice as necessary to stay compliant with relevant laws.
        </em>
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        We may update this Privacy Notice from time to time. The updated version will be indicated by an updated 
        <span style={{ fontWeight: 'bold' }}> "Revised" </span> date at the top of this Privacy Notice. If we make material changes to this Privacy Notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this Privacy Notice frequently to be informed of how we are protecting your information.
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div id="contact">
        <strong>
          <h2>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>
        </strong>
        <div>
          If you have questions or comments about this notice, you may 
          <span style={{ color: 'rgb(89, 89, 89)' }}>
            email us at <span style={{ fontWeight: 'bold' }}>support@xcutta.com</span> or 
          </span>
          contact us by post at:
        </div>
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        2025, Gadi Enterprises, Inc.
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        __________
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div>
        United States
      </div>
      <div style={{ lineHeight: '1.5' }}><br /></div>
      <div id="request">
        <strong>
          <h2>13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h2>
        </strong>
        <div>
          You have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. To request to review, update, or delete your personal information, please 
          <span style={{ color: 'rgb(0, 58, 250)' }}>
            <a 
              href="https://app.termly.io/notify/94bf533d-5a0e-49aa-bb1f-688fdb24cf50" 
              rel="noopener noreferrer" 
              target="_blank"
            >
              data subject access request
            </a>
          </span>.
        </div>
      </div>
      <style>
        {`
          ul {
            list-style-type: square;
          }
          ul > li > ul {
            list-style-type: circle;
          }
          ul > li > ul > li > ul {
            list-style-type: square;
          }
          ol li {
            font-family: Arial;
          }
        `}
      </style>
    </div>
        </div>
        
        </>
    );
};

export default PrivacyPolicy;
